import I18n from 'I18n';
import { sortBy } from 'underscore';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { PropertyObjectTypes } from 'forms-utils-lib/constants/PropertyObjectTypes';
import { FieldTypes } from 'forms-utils-lib/constants/formField/FieldTypeMapping';
import getDefaultMetaDataValues from 'forms-utils-lib/formField/lib/getDefaultMetaDataValues';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import FieldType from 'forms-utils-lib/constants/formField/FieldType';
import createFormField from './createFormField';
import getObjectTypeIdValue from './getObjectTypeIdValue';
import getPropertyObjectTypeValue from './getPropertyObjectTypeValue';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
const createFormFieldWithOptions = (fieldOptions = {}, isSmartField = false, isRequired = false, locale = I18n.locale) => {
  const {
    name = '',
    label = '',
    type = FieldType.STRING,
    fieldType = FieldTypes.TEXT,
    options = [],
    groupName = '',
    propertyObjectType = PropertyObjectTypes.CONTACT,
    hidden = false,
    objectTypeId
  } = fieldOptions;
  const objectTypeIdValue = getObjectTypeIdValue(propertyObjectType, objectTypeId);
  return createFormField({
    type,
    fieldType,
    groupName,
    label: sanitize(label, config.HTML),
    propertyObjectType: getPropertyObjectTypeValue(objectTypeIdValue),
    objectTypeId: objectTypeIdValue,
    name,
    isSmartField,
    hidden,
    required: isRequired,
    options: sortBy(options.filter(option => !option.hidden), FormFieldKeys.DISPLAY_ORDER),
    metaData: getDefaultMetaDataValues(fieldType, locale)
  });
};
export default createFormFieldWithOptions;